import axios from 'axios';
import { getAddressApiBackendUrl } from '../utils';
const addressApiClient = axios.create();
export default addressApiClient;
export const initializeAddressApiClient = (isProd, localBackendUrl) => {
    const backendUrl = getAddressApiBackendUrl(isProd, localBackendUrl);
    addressApiClient.defaults.baseURL = `${backendUrl}`;
};
